export const ADD_QUESTION = 'ADD_QUESTION';
export const TOGGLE_OPTION = 'TOGGLE_OPTION';
export const TOGGLE_OPTION_VARIATION = 'TOGGLE_OPTION_VARIATION';
export const TOGGLE_OPTION_VARIATION_ACCORDION = 'TOGGLE_OPTION_VARIATION_ACCORDION';
export const RESET_CONFIG = 'RESET_CONFIG';
export const ADD_OPTION = 'ADD_OPTION';
